export default __webpack_public_path__ + "static/media/WonProposalActive.38dfd1f5.svg";